export class CriteresEvaluationJure {
    static jsonMap = {
        id: 'id',
        idOrganisme: 'idOrganisme',
        libelleCritere: 'libelleCritere',
        pointsOui: 'pointsOui',
        pointsNon: 'pointsNon'
    };

    id: number;
    idOrganisme: number;
    libelleCritere: string;
    pointsOui: number;
    pointsNon: number;
}
